export default __webpack_public_path__ + "static/media/m_logo.aa357283.png";